// Central styled-components theme — the dark, terminal-flavored palette from the
// PRD "Visual system" section. Exact pixel values from the Claude Design handoff
// are ported once design-login is authorized; until then these are the spec.
export const theme = {
  color: {
    // Base + surfaces
    base: "#08090C",
    surface: "#12161D",
    surfaceRaised: "#1A1F28",
    surfaceAlt: "#0E1218", // deep tier for riddle/quest gradients
    // Borders are translucent white so they read correctly over the hero/riddle
    // glows (design uses rgba borders everywhere, not solid hexes).
    border: "rgba(255, 255, 255, 0.06)",
    borderHi: "rgba(255, 255, 255, 0.12)",
    // TON accent
    accent: "#0098EA",
    accentDim: "#0077b8", // solid darker blue (avatar/bubble fills)
    accentSoft: "rgba(0, 152, 234, 0.15)", // translucent accent fill (chips, you-marker)
    accentGlow: "rgba(0, 152, 234, 0.32)", // button/avatar glow shadows
    // Text
    text: "#F5F7FA",
    textDim: "#8A93A3",
    textFaint: "#5A6273",
    // Status
    good: "#3FCF8E",
    warn: "#E5B567",
    bad: "#E5675B",
    danger: "#FF5C5C",
    // Per-meter colors (by type, with glow) — also reused as category accents:
    // caregiver→satiety, solver→happiness, quest→accent.
    satiety: "#3DD68C", // green
    hygiene: "#5BC8FF", // cyan
    happiness: "#FFB020", // amber
    // Mood / accents
    happy: "#3FCF8E",
    asleep: "#5A6273",
  },
  font: {
    ui: "'Space Grotesk', system-ui, -apple-system, sans-serif",
    mono: "'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, monospace",
  },
  radius: {
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "22px",
    xxl: "24px",
    pill: "999px",
  },
  space: (n: number) => `${n * 4}px`,
  maxWidth: "480px",
} as const;

export type AppTheme = typeof theme;
